import { providerDefaultOptions } from '@ankr.com/provider';
import { OEvmWalletId } from '../types';
import { tomoConnector } from './tomoConnector';
import { binanceWeb3Connector } from './binanceWeb3Connector';

export const providerOptions: typeof providerDefaultOptions = {
  ...providerDefaultOptions,
  [OEvmWalletId.tomo]: {
    connector: tomoConnector,
  },
  [OEvmWalletId.binanceWallet]: {
    connector: binanceWeb3Connector,
  },
};
